import { Customer } from '../models/customer';
import { makeAutoObservable, runInAction } from 'mobx';
import agent from './../api/agent';
import { toast } from 'react-toastify';

export default class CustomerStore {
  customerRegistery = new Map<string, Customer>();
  selectedCustomer: Customer | undefined = undefined;
  loading = false;
  loadingInitial = false;

  constructor() {
    makeAutoObservable(this);
  }
  get customeritemsByDate() {
    return Array.from(this.customerRegistery.values());
  }
  setLoadingInitial = (state: boolean) => {
    this.loadingInitial = state;
  };

  private setcustomers = (Customer: Customer) => {
    this.customerRegistery.set(Customer.id, Customer);
  };
  private getcustomers = (id: string) => {
    return this.customerRegistery.get(id);
  };

  loadCustomers = async () => {
    this.loading = true;
    try {
      const customers = await agent.Customers.list();
      customers.forEach((customers) => {
        runInAction(() => {
          this.setcustomers(customers);
        });
      });
      this.loading = false;
    } catch (err) {
      console.log(err);
    }
  };
  //    single Customer
  loadCustomer = async (id: string) => {
    this.loading = true;

    this.loadingInitial = true;
    try {
      const customerDetail = await agent.Customers.details(id);
      this.setcustomers(customerDetail);
      runInAction(() => {
        this.selectedCustomer = customerDetail;
      });
      this.setLoadingInitial(false);
      return customerDetail;
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
    }
  };
  createCustomer = async (Customer: Customer) => {
    this.loading = true;
    try {
      await agent.Customers.create(Customer);

      runInAction(() => {
        this.customerRegistery.set(Customer.id, Customer);
        this.selectedCustomer = Customer;
        //this.editMode = false;
        this.loading = false;
      });
      toast.success('Customer Record Created Successfully ');
    } catch (error) {
      console.log(error);
      runInAction(() => {
        this.loading = false;
      });
    }
  };
  updateCustomer = async (Customer: Customer) => {
    this.loading = true;

    try {
      await agent.Customers.update(Customer);

      runInAction(() => {
        this.customerRegistery.set(Customer.id, Customer);
        this.selectedCustomer = Customer;
        // this.editMode = false;
        this.loading = false;
      });
      toast.success('Customer Record Updated Succesfully.');
      toast.info('Email Sent Successfully ');
    } catch (error) {
      console.log(error);
      runInAction(() => {
        this.loading = false;
      });
    }
  };
  deleteCustomer = async (Customer: Customer) => {
    try {
      await agent.Customers.delete(Customer);

      runInAction(() => {
        this.customerRegistery.delete(Customer.id);
      });
      toast.success('Customer Deleted Succesfully.');
      toast.info('Email Sent Successfully');
    } catch (error) {
      runInAction(() => {
        console.log(error);
      });
    }
  };
}
